import { Box, BoxProps } from '@mantine/core'
import { ScheduleEventCard, SpotlightLeadgenSession } from 'interfaces/types'
import LeadgenWithBanner, {
  LeadgenWithBannerHandlerProps,
} from '../../leadgenWithBanner'
import useStyles from './index.styles'
import { GameRules } from '../gameRules'
import { forwardRef, ForwardRefRenderFunction } from 'react'

const LeadgenSection: ForwardRefRenderFunction<
  LeadgenWithBannerHandlerProps,
  {
    campaign: any
    event: ScheduleEventCard
  } & BoxProps
> = ({ campaign, event, styles, classNames }, ref) => {
  const { classes, theme } = useStyles(undefined, {
    name: 'ScheduleEvent___LeadgenSection',
    styles,
    classNames,
  })
  const leadProps = {
    isSkippable: true,
    campaignCode: campaign.code,
    banner: {
      desktop: event?.leadgenCampaign.bannerDesktop || '',
      mobile: event?.leadgenCampaign.bannerMobile || '',
    },
    thankYouMessage: (() => {
      const listBlockThankyou = JSON.parse(
        campaign.extra_fields?.listBlockThankyou || null,
      )
      return {
        title:
          listBlockThankyou?.find((i: any) => i.name == 'TitleBlock')?.data
            ?.value || '',
        description:
          listBlockThankyou?.find((i: any) => i.name == 'SubtitleBlock')?.data
            ?.value || '',
      }
    })(),
    campaigns: campaign,
  } as SpotlightLeadgenSession
  return (
    <>
      {event.leadgenCampaign.enableLeadgenInline && (
        <Box className={classes.leadWrapper}>
          <LeadgenWithBanner
            classNames={{
              root: classes.leadInlineRoot,
              formFrame: classes.leadFormFrame,
            }}
            scrollable
            data={leadProps}
            // primaryColor={activeTheme.primary}
            // styles={leadgenStyles}
            // onCloseForm={() => {
            //   if (url) {
            //     window.open(url)
            //   }
            // }}
          />
          <GameRules
            styles={{
              root: {
                [theme.fn.smallerThan('sm')]: {
                  backgroundImage:
                    'linear-gradient(139.59deg, #2338F7 2.87%, #021575 89.05%)',
                },
                [theme.fn.largerThan('sm')]: {
                  paddingBottom: 0,
                },
              },
            }}
          />
        </Box>
      )}
      <LeadgenWithBanner
        isModal
        scrollable
        desktopModalType="normal"
        mobileModalType="drawer"
        ref={ref}
        classNames={{
          root: classes.leadModalRoot,
          formFrame: classes.leadFormFrame,
          wrapper: classes.leadModalWrapper,
        }}
        data={leadProps}
        // primaryColor={activeTheme.primary}
        // styles={leadgenStyles}
        // onCloseForm={() => {
        //   if (url) {
        //     window.open(url)
        //   }
        // }}
      />
    </>
  )
}
export default forwardRef(LeadgenSection)
